var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoadReception = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#LoadReception_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.414 10.8 20.17 7.069a1.735 1.735 0 0 0-1.64-1.184h-4.803c-.95 0-1.727.778-1.727 1.728v3.454H2.5v4.319c0 .95.777 1.727 1.727 1.727h.864a2.587 2.587 0 0 0 2.59 2.59 2.587 2.587 0 0 0 2.592-2.59h3.454a2.587 2.587 0 0 0 2.591 2.59 2.587 2.587 0 0 0 2.591-2.59H21.5v-5.77q.002-.27-.086-.543M7.682 17.976a.866.866 0 0 1-.864-.863c0-.475.389-.864.864-.864s.863.389.863.864a.866.866 0 0 1-.863.863m8.636 0a.866.866 0 0 1-.864-.863c0-.475.39-.864.864-.864.475 0 .864.389.864.864a.866.866 0 0 1-.864.863m-2.59-6.909V7.613h4.801l1.149 3.454z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 5.022c0-.954.773-1.727 1.727-1.727H9.41c.954 0 1.727.773 1.727 1.727v5.182H2.5z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "LoadReception_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgLoadReception;